// Railtek Belt Builder: buckle -> strap -> one bundle line in the cart.
if (!customElements.get('rt-builder')) {
  const GROUPS = ['Leather', 'Contrast Stitch', 'Tanned Leather', 'Suede', 'Polyester', 'Nylon', 'Canvas'];
  const groupOf = (title) => {
    if (/suede/i.test(title)) return 'Suede';
    if (/tanned/i.test(title)) return 'Tanned Leather';
    if (/contrast stitch/i.test(title)) return 'Contrast Stitch';
    if (/polyester/i.test(title)) return 'Polyester';
    if (/nylon/i.test(title)) return 'Nylon';
    if (/canvas/i.test(title)) return 'Canvas';
    return 'Leather';
  };
  const shortName = (title) => {
    const matte = /matte /i.test(title);
    const t = title.replace(/ Contrast Stitch| Canvas| Nylon| Polyester| Suede/gi, '').replace(/Tanned Leather |Matte /gi, '');
    return matte ? `${t} (Matte)` : t;
  };
  const money = (cents) => {
    const d = cents / 100;
    return '$' + (Number.isInteger(d) ? d.toFixed(0) : d.toFixed(2));
  };
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  };

  class RtBuilder extends HTMLElement {
    connectedCallback() {
      const data = JSON.parse(this.querySelector('[data-belts]').textContent);
      this.belts = new Map(data.belts.map((b) => [b.handle, b]));
      this.strapPrices = data.strapPrices || {};
      this.bucklePrice = Number(this.dataset.bucklePrice) || 0;
      this.buckle = null;
      this.variant = null;

      this.strapsEl = this.querySelector('[data-straps]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.ui = {
        pic: this.querySelector('[data-pic]'),
        name: this.querySelector('[data-name]'),
        strap: this.querySelector('[data-strap]'),
        save: this.querySelector('[data-save]'),
        price: this.querySelector('[data-price]'),
        add: this.querySelector('[data-add]'),
        addLabel: this.querySelector('[data-add-label]'),
        error: this.querySelector('[data-error]'),
      };

      this.querySelectorAll('.rt-buckle__btn').forEach((btn) =>
        btn.addEventListener('click', () => this.pickBuckle(btn.dataset.handle, true))
      );
      this.querySelectorAll('.rt-lane').forEach((btn) => btn.addEventListener('click', () => this.filter(btn)));
      this.ui.add.addEventListener('click', () => this.addToCart());

      const params = new URLSearchParams(location.search);
      const start = params.get('buckle');
      this.preferStrap = params.get('strap');
      if (this.preferStrap && !(start && this.belts.has(start))) {
        this.ui.strap.textContent = `${this.preferStrap} strap picked. Now choose a buckle`;
      }
      if (start && this.belts.has(start)) {
        this.pickBuckle(start, false);
        const strap = params.get('strap');
        if (strap) {
          const v = this.belts.get(start).variants.find((x) => x.title.toLowerCase() === strap.toLowerCase() && x.available);
          if (v) this.pickStrap(v);
        }
      }
    }

    filter(btn) {
      const lane = btn.dataset.lane;
      this.querySelectorAll('.rt-lane').forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on);
      });
      this.querySelectorAll('.rt-buckle').forEach((li) => {
        li.hidden = lane !== 'all' && !li.dataset.lanes.split(' ').includes(lane);
      });
    }

    pickBuckle(handle, scroll) {
      const belt = this.belts.get(handle);
      if (!belt) return;
      this.buckle = belt;
      this.querySelectorAll('.rt-buckle__btn').forEach((b) => {
        const on = b.dataset.handle === handle;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on);
      });

      // Keep the same strap if this buckle offers it.
      const wanted = this.variant ? this.variant.title : this.preferStrap;
      const keep = wanted && belt.variants.find((v) => v.title.toLowerCase() === wanted.toLowerCase() && v.available);
      this.variant = keep || null;
      this.renderStraps();
      this.renderSummary();
      if (scroll) this.querySelector('[data-step="2"]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    renderStraps() {
      const belt = this.buckle;
      this.emptyEl.hidden = true;
      this.strapsEl.hidden = false;
      this.strapsEl.replaceChildren();
      const byGroup = new Map(GROUPS.map((g) => [g, []]));
      belt.variants.forEach((v) => byGroup.get(groupOf(v.title)).push(v));

      byGroup.forEach((list, group) => {
        if (!list.length) return;
        const wrap = el('div', 'rt-strap-group');
        wrap.append(el('h3', 'rt-strap-group__name', group));
        const ul = el('ul', 'rt-strap-list');
        ul.setAttribute('role', 'list');
        list.forEach((v) => {
          const li = el('li');
          const b = el('button', 'rt-strap');
          b.type = 'button';
          b.disabled = !v.available;
          b.setAttribute('aria-pressed', this.variant && this.variant.id === v.id ? 'true' : 'false');
          if (this.variant && this.variant.id === v.id) b.classList.add('is-on');
          if (v.image) {
            const img = el('img', 'rt-strap__img');
            img.src = v.image;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 200;
            img.height = 200;
            b.append(img);
          }
          b.append(el('span', 'rt-strap__name', shortName(v.title)));
          b.setAttribute('aria-label', `${v.title}, ${money(v.price)}`);
          b.append(el('span', 'rt-tag', v.available ? money(v.price) : 'Sold out'));
          b.addEventListener('click', () => this.pickStrap(v, b));
          li.append(b);
          ul.append(li);
        });
        wrap.append(ul);
        this.strapsEl.append(wrap);
      });
    }

    pickStrap(v, btn) {
      this.variant = v;
      this.strapsEl.querySelectorAll('.rt-strap').forEach((b) => {
        b.classList.remove('is-on');
        b.setAttribute('aria-pressed', 'false');
      });
      if (btn) {
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        this.renderStraps();
      }
      this.renderSummary();
    }

    renderSummary() {
      const { ui, buckle, variant } = this;
      ui.error.hidden = true;
      ui.name.textContent = buckle ? `${buckle.name} buckle` : 'No buckle yet';
      ui.strap.textContent = variant ? `${variant.title} strap` : buckle ? 'Now pick a strap' : 'Pick a buckle, then a strap';

      const picSrc = variant ? variant.image : buckle ? buckle.image : null;
      ui.pic.replaceChildren();
      if (picSrc) {
        const img = el('img');
        img.src = picSrc;
        img.alt = '';
        ui.pic.append(img);
      }

      let price = null;
      if (variant) price = variant.price;
      else if (buckle) price = Math.min(...buckle.variants.filter((v) => v.available).map((v) => v.price));
      const label = price === null ? '' : variant ? money(price) : `from ${money(price)}`;
      if (ui.price.textContent !== label) {
        ui.price.textContent = label || ' ';
        ui.price.classList.remove('is-flip');
        void ui.price.offsetWidth;
        if (label) ui.price.classList.add('is-flip');
      }

      ui.price.hidden = !label;
      const strapAlone = variant ? this.strapPrices[variant.title] : undefined;
      const savings = variant && strapAlone ? this.bucklePrice + strapAlone - variant.price : 0;
      ui.save.hidden = !(savings > 0);
      if (savings > 0) ui.save.textContent = `Save ${money(savings)} vs. buying the buckle and strap separately`;

      ui.add.disabled = !variant;
      ui.addLabel.textContent = variant ? `Add belt to cart · ${money(variant.price)}` : 'Add to cart';
      this.classList.toggle('has-pick', Boolean(buckle));
    }

    async addToCart() {
      if (!this.variant) return;
      const { ui } = this;
      ui.add.disabled = true;
      ui.add.setAttribute('aria-busy', 'true');
      ui.addLabel.textContent = 'Adding…';
      ui.error.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      const body = { items: [{ id: this.variant.id, quantity: 1 }] };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = location.pathname;
      }
      try {
        const res = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add this belt.');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rt-builder', productVariantId: this.variant.id });
        }
        if (drawer) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(json);
        } else {
          location.href = window.routes ? window.routes.cart_url : '/cart';
          return;
        }
      } catch (e) {
        ui.error.textContent = `${e.message} Try again, or pick another strap.`;
        ui.error.hidden = false;
      }
      ui.add.removeAttribute('aria-busy');
      this.renderSummary();
    }
  }

  customElements.define('rt-builder', RtBuilder);
}
